import {makeStyles} from '@material-ui/styles';
import React from 'react';

import {Topbar} from './Topbar';
import {ContactUsBar} from '../ContactUsBar';
import {checkIsAdmin} from '../../utils/checkIsAdmin';
import {getMe} from '../../graphql/auth';

const useStyles = (showingContactusBar: boolean) => makeStyles(() => ({
    root: {
        paddingTop: 83,
        paddingBottom: showingContactusBar ? 83 : 0,
        height: '100%'
    },
    content: {
        height: '100%',
        padding: 0,
    }
}));

export const Minimal = (props: { children?: any, className?: string }) => {
    const {children} = props;
    const isAdmin = checkIsAdmin();
    const meData = getMe();
    const me = meData && meData.data && meData.data.me;
    const showingContactusBar = !(!me || isAdmin);

    const classes = useStyles(showingContactusBar)();

    return (
        <div className={classes.root}>
            <Topbar/>
            <main className={classes.content}>{children}</main>
            <ContactUsBar/>
        </div>
    );
};

export default Minimal;
